define('commons/flat-tree-popup-group',['jquery', 'commons/flat-tree-popup', 'commons/flat-tree-group'], function($, FlatTreePopup, FlatTreeGroup) {
    
    var FlatTreePopupGroup = function(triggerSelector, popupOptions, flatTreeOptions, options) {
        FlatTreePopup.call(this, triggerSelector, $.extend({
            'title': 'Select a group'
        }, popupOptions), $.extend({
            createTree: function(container) {
                return new FlatTreeGroup(container, $.extend({
                    autoLoad: false,
                    nbPanels: 2
                }, flatTreeOptions));
            }
        }, options));
    };

    // Inherit from FlatTreePopup
    for (var element in FlatTreePopup.prototype) {
        FlatTreePopupGroup.prototype[element] = FlatTreePopup.prototype[element];
    }
    
    return FlatTreePopupGroup;
    
});
